module.exports = __webpack_public_path__ + "img/printer.458f30a7.svg";